import React from "react";
import { string, number, arrayOf, bool, shape } from "prop-types";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";
import * as numberUtils from "util/number";
import * as configUtils from "util/config";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";

const DepositDetailList = (props) => {
    // const [newListData, setNewListData] = useState([]);

    // useEffect(() => {
    //     setNewListData(createListDataStructure(dataToList));
    // }, [dataToList]);

    const { isDesktop, deposit } = props;

    const depositTypeTransferable = configUtils.get("deposit.depositType.cedip.transferable");

    const certificateCedip = "82108051010001"; // TODO: Cambiar cuando el servicio retorne el valor del cedip

    return (
        <GridTable className="deposit-details-list details">
            <div className=" hidden show-print">
                <div className="acct-number-label toolbar-item">
                    <I18n id="deposits.certificateTitle" />
                    <>:&bsp;&bsp;</>
                </div>
                <div className="acct-number toolbar-item">
                    <strong>
                        <I18n id="global.number" /> {`${deposit.depositNumber}`}
                    </strong>
                </div>
            </div>
            <GridTable.Container key={deposit.idProduct} columns={isDesktop ? 3 : 1} rows={isDesktop ? 2 : 11}>
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText="deposits.type"
                        titleTextType="I18N"
                        titleClass="text-Primary-primary-color"
                        valueText={deposit.shortLabel}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomData
                        titleText="deposits.expirationDate"
                        titleTextType="I18N"
                        valueText={deposit.dueDateFormatted}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                    <CustomData
                        titleText="deposits.chargeAmount"
                        titleTextType="I18N"
                        valueText={deposit.amountTransfered}
                        valueTextType={deposit.currency}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4}>
                    <CustomData
                        titleText="deposits.capitalInvested"
                        titleTextType="I18N"
                        valueText={deposit.amountInvested}
                        valueTextType={deposit.currency}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5}>
                    <CustomData
                        titleText="deposits.tnaDetail"
                        titleTextType="I18N"
                        valueText={deposit.rate}
                        valueTextType="PERCENTAGE"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 6}>
                    <CustomData
                        titleText="deposits.interestGained"
                        titleTextType="I18N"
                        valueText={deposit.interest}
                        valueTextType={deposit.currency}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} columnWidth={isDesktop && 3} rowStart={isDesktop ? 3 : 7}>
                    <hr className="dotted" />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 4 : 8}>
                    <CustomData
                        titleText="deposits.creationDate"
                        titleTextType="I18N"
                        valueText={deposit.openDateFormatted}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data
                    columnStart={!isDesktop ? 1 : 2}
                    columnWidth={isDesktop && 3}
                    rowStart={isDesktop ? 4 : 9}>
                    <CustomData titleText="deposits.termInDays" titleTextType="I18N" valueText={deposit.deadline} />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 4 : 10}>
                    <CustomData
                        titleText="deposits.retentions"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                currency={deposit.currency}
                                quantity={numberUtils.formatAmountStrDouble(deposit.retention)}
                            />
                        }
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 11}>
                    <CustomData
                        titleText="deposits.autoRenewal"
                        titleTextType="I18N"
                        valueText={deposit.autoRenewal ? i18n.get(`deposits.autoRenewal.${deposit.autoRenewal}`) : "-"}
                    />
                </GridTable.Data>
                {deposit.depositType === depositTypeTransferable && (
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 5 : 12}>
                        <CustomData
                            titleText="deposits.certificate.cedip"
                            titleTextType="I18N"
                            valueText={certificateCedip}
                        />
                    </GridTable.Data>
                )}
            </GridTable.Container>
        </GridTable>
    );
    // return <CustomList listData={newListData} isMobile={isMobile} className="details underlined" />;
};

DepositDetailList.propTypes = {
    deposit: arrayOf(
        shape({
            depositTypeNum: string.isRequired,
            expiration: number.isRequired,
            chargeAmount: number,
            capitalInvested: number.isRequired,
            tna: number,
            interestGained: number,
            creationDate: number,
            termInDays: number,
            autoRenewal: string,
            anticipatedCancelation: bool,
        }),
    ).isRequired,
    isDesktop: bool,
};

DepositDetailList.defaultProps = { isDesktop: bool };

export default DepositDetailList;
